import { Icon } from '@chakra-ui/react';

const CustomIssuanceFormIcon = (props) => (
  <Icon viewBox="0 0 29 33" fill="none" {...props}>
    <path
      d="M1 7.73975C1 4.56196 1 2.97475 1.98737 1.98737C2.97475 1 4.56196 1 7.73975 1H21.2192C24.397 1 25.9842 1 26.9716 1.98737C27.959 2.97475 27.959 4.56196 27.959 7.73975V21.2192C27.959 25.9842 27.959 28.3684 26.4779 29.8478C24.9986 31.3289 22.6144 31.3289 17.8494 31.3289H11.1096C6.34462 31.3289 3.96043 31.3289 2.48106 29.8478C1 28.3684 1 25.9842 1 21.2192V7.73975Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M19.5344 26.2742V31.329M9.4248 26.2742V31.329M9.4248 9.4248H19.5344M9.4248 16.1646H19.5344"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </Icon>
);

export default CustomIssuanceFormIcon;
